import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';

@Injectable()
export class LogicielCaisseInterceptor implements HttpInterceptor {
  private readonly lcBase: string;

  constructor(private readonly lcAuth: LogicielCaisseAuthService) {
    const raw =
      environment.api_logiciel_caisse ??
      (environment as { base_api_logiciel_caisse?: string }).base_api_logiciel_caisse ??
      '';
    this.lcBase = String(raw).replace(/\/$/, '');
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.lcBase || !this.matchesLcApi(request.url)) {
      return next.handle(request);
    }

    const token = this.lcAuth.getLogicielCaisseToken();
    if (!token) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }

  private matchesLcApi(url: string): boolean {
    if (url.startsWith(this.lcBase)) {
      return true;
    }
    if (this.lcBase.startsWith('/')) {
      try {
        const pathname = new URL(url, 'http://localhost').pathname;
        return pathname === this.lcBase || pathname.startsWith(`${this.lcBase}/`);
      } catch {
        return false;
      }
    }
    return false;
  }
}
